<template>
  <v-card
    ref="mainCard"
    class="ma-0 overflow-y-auto"
    width="100%"
    flat
    style="height: 100vh;position: fixed"
  >
    <v-card
      flat
      class="ma-3 mt-0 mr-0"
      width="100%"
      style="height: auto"
    >
      <v-row class="mb-0 mx-0 pb-0">
        <v-col
          class="mb-0 pt-3 pb-0 pr-2 "
          cols="6"
          style="height: 40px"
        >
          <v-chip
            outlined
            @click="head"
          >
            <v-icon
              color="primary"
              left
            >
              mdi-account-edit
            </v-icon>
            {{ (header && header.customer ? header.customer.name : '') }}
          </v-chip>
        </v-col>
        <v-col
          class="mb-0 pt-3 pb-0 pr-2 pl-2 flex-row-reverse d-flex"
          cols="6"
          style="height: 40px"
        >
          <v-btn
            small
            color="primary"
            icon
            @click="sheet = !sheet"
          >
            <v-icon>
              mdi-filter
            </v-icon>
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                small
                v-on="on"
                @click="taxDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-percent-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('tax') }} & {{ $t('discount') }}</span>
          </v-tooltip>
            <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
            v-model="taxDialog"
            width="95%"
          >
            <v-card>
              <v-card-title>
                {{ $t('additional-informarion') }}
              </v-card-title>
              <v-card-text>
                <v-container
                  class="overflow-y-auto"
                  style="height: 300px"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="1"
                      class="mb-1"
                      md="1"
                    >
                      <v-switch
                        v-model="tax"
                        :label="$t('tax')"
                        @change="calculate"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      class="mb-1"
                      md="3"
                    >
                      <vuetify-money
                        v-model="sumTax"
                        :label="$t('tax')"
                        :dense="true"
                        :solo="false"
                        :disabled="true"
                        :outlined="true"
                        :clearable="true"
                        value-when-is-empty="0"
                        :options="options"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      md="3"
                      class="mb-1"
                    >
                      <vuetify-money
                        v-model="sumDiscount"
                        :label="$t('discount')"
                        :solo="false"
                        :dense="true"
                        :outlined="true"
                        :clearable="true"
                        value-when-is-empty="0"
                        :options="options"
                        :value-options="{'max':sumPrice}"
                        @SetValueMax="SetValueMaxTotalDiscount()"
                        @input="totalDiscount()"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="3"
                      md="3"
                    >
                      <vuetify-money
                        v-model="sumDiscountPercent"
                        :label="$t('discountPercent')"
                        :dense="true"
                        :solo="false"
                        :outlined="true"
                        :clearable="true"
                        value-when-is-empty="0"
                        :options="{'locale':'en-Us','precision':2,'length':5,'suffix':'%'}"
                        :value-options="{'max':100}"
                        @SetValueMax="SetValueMaxTotalDiscountPercent()"
                        @input="totalDiscountPercentCheck()"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  depressed
                  color="error"
                  text
                  @click="taxDialog = false"
                >
                  {{ $t('close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                small
                v-on="on"
                @click="productDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('add-product') }}</span>
          </v-tooltip>
            <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
            v-model="productDialog"
            width="95%"
          >
            <v-card>
              <v-card-text>
                <v-container
                  class="overflow-y-auto"
                  style="height: auto"
                >
                  <product v-model="newProduct" />
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  depressed
                  color="error"
                  text
                  @click="productDialog = false"
                >
                  {{ $t('close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                small
                class="mx-1"
                v-on="on"
                @click="changeSelectByBarcode"
              >
                <v-icon
                  v-if="selectByBarcode"
                  medium
                >
                  mdi-barcode
                </v-icon>
                <v-icon
                  v-if="!selectByBarcode"
                  medium
                >
                  mdi-barcode-off
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('select-by-barcode') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row class="mx-1 mb-0">
        <v-col
          class="mb-0 pb-0 px-1"
          cols="4"
          md="4"
          sm="4"
          style="height: 55px"
        >
          <combobox
            v-model="entrepot"
            :label="$t('entrepot')"
            type="entrepot"
            class="mb-0"
          />
        </v-col>
        <v-col
          class="mb-0 pb-0 px-1"
          cols="8"
          md="8"
          sm="8"
          style="height: 55px"
        >
          <v-text-field
            ref="searchField"
            v-model="search"
            :label="$t('search')"
            outlined
            clearable
            height="20"
            :loading="loading"
            :disabled="searchDisable"
            dense
            class="mb-0"
            @keydown="test"
          />
        </v-col>
      </v-row>
      <v-row class="mx-0">
        <v-col
          cols="12"
          class="pt-0 px-0"
        >
          <v-list
            ref="scrollContainer"
            v-model="selected"
            nav
            dense
            class="overflow-y-auto px-0"
            :height="listHeight"
            style="overflow-x: hidden"
            @keydown="test"
          >
            <v-list-item
              v-for="(item, i) in lists"
              :key="i"
              ref="test"
              :class="{ 'border-item' : item.selected}"
              class="my-0 py-0 px-0 mb-2"
              style="box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 10px 0 rgba(0, 0, 0, 0.1);"
            >
              <v-list-item-avatar class="ml-2">
                  <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
                  v-model="item.dialog"
                  width="95%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      icon
                      v-on="on"
                      @click="openDialog(item)"
                    >
                      <v-icon
                        medium
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title>
                      {{ item.name }} - {{ item.code }}
                    </v-card-title>
                    <v-card-text>
                      <v-container
                        class="overflow-y-auto"
                        style="height: 300px"
                      >
                        <v-alert
                          v-if="item.feeAlert"
                          dense
                          outlined
                          class="pa-0"
                          type="error"
                        >
                          {{ $t('alert-fee-smaller-than-cost-or-equal') }}
                        </v-alert>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                          >
                            <v-text-field
                              v-model="item.count"
                              :label="$t('count')"
                              height="20"
                              :loading="item.loading"
                              dense
                              outlined
                              class="mb-1 dense"
                              clearable
                              type="number"
                              @change="countChange(item)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            class="mb-1"
                          >
                            <vuetify-money
                              v-model="item.fee"
                              :label="$t('fee')"
                              :dense="true"
                              :solo="false"
                              :outlined="true"
                              :clearable="true"
                              value-when-is-empty="0"
                              :options="options"
                              :value-options="{'min':item.goodcost,'max':item.goodcost}"
                              @SetValueMin="SetValueMinFee(item)"
                              @SetValueMax="SetValueMaxFee(item)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                            class="mb-1"
                          >
                            <vuetify-money
                              v-model="item.discount"
                              :label="$t('discount')"
                              :dense="true"
                              :solo="false"
                              :outlined="true"
                              :clearable="true"
                              value-when-is-empty="0"
                              :options="options"
                              :value-options="{'max':item.fee*item.count}"
                              @SetValueMax="SetValueMaxDiscount(item)"
                              @input="discount(item)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            md="3"
                          >
                            <vuetify-money
                              v-model="item.discountPercent"
                              :label="$t('discountPercent')"
                              :dense="true"
                              :solo="false"
                              :outlined="true"
                              :clearable="true"
                              value-when-is-empty="0"
                              :options="{'locale':'en-Us','precision':2,'length':5,'suffix':'%'}"
                              :value-options="{'max':100}"
                              @SetValueMax="SetValueMaxDiscountPercent(item)"
                              @input="discountPercentCheck(item)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="3"
                            class="mb-1"
                            md="3"
                          >
                            <vuetify-money
                              v-model="item.tax"
                              :label="$t('tax')"
                              :dense="true"
                              :disabled="true"
                              :solo="false"
                              :outlined="true"
                              :clearable="true"
                              :options="options"
                              value-when-is-empty="0"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        depressed
                        color="error"
                        text
                        @click="item.dialog = false"
                      >
                        {{ $t('close') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-list-item-avatar>
              <v-list-item-content
                style="cursor: pointer"
              >
                <v-list-item-title
                  style="white-space: unset !important;"
                  @click="click(item , i)"
                >
                  {{ item.name }}
                  <v-btn
                    class="ma-2"
                    color="primary"
                    outlined
                    x-small
                    icon
                  >
                    <v-icon
                      dark
                    >
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </v-list-item-title>
                <v-list-item-subtitle v-if="item.type == 8">
                  {{ (item.stock != undefined ? $t('stock')+' : '+item.stock + '-' : '' ) }}  {{ $t('unit')+ ' : '+ item.unitName }}    {{ (item.entrepotName ?  '-'+ $t('entrepot')  +' : '+item.entrepotName : '')}}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.type !== 8">
                 {{$t('service')}}  {{ (item.unitName != undefined ?  '-'+ $t('unit')+ ' : '+ item.unitName : '') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="item.count > 0"
                  style="white-space: normal !important;"
                  @click="item.dialog = true"
                >
                  <v-chip
                    link
                    outlined
                    color="green"
                    draggable
                    small
                    class="ml-2 mb-1"
                  >
                    {{ $t('sum') }} : {{ $numberFormat(item.count*item.fee) }}
                  </v-chip>
                  <v-chip
                    link
                    outlined
                    color="red"
                    draggable
                    small
                    class="ml-2 mb-1"
                  >
                    {{ $t('discount') }} : {{ $numberFormat(Number(item.discount)) }}
                  </v-chip>
                  <v-chip
                    link
                    outlined
                    color="blue"
                    draggable
                    small
                    class="ml-2 mb-1"
                  >
                    {{ $t('tax') }} : {{ $numberFormat(Number(item.tax)) }}
                  </v-chip>
                  <v-chip
                    link
                    outlined
                    draggable
                    small
                    class="ml-2 mb-1"
                  >
                    {{ $t('sum-total') }} : {{ $numberFormat(parseInt(item.count*item.fee)+Number(item.tax)-Number(item.discount)) }}
                  </v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="my-2">
                <v-row
                  style="height: 25px;max-width: 110px"
                  class="my-0 py-0 pl-3"
                >
                  <v-text-field
                    v-model="item.count"
                    :label="$t('count')"
                    solo
                    flat
                    height="20"
                    :loading="item.loading"
                    dense
                    clearable
                    type="number"
                    class="mb-0 dense"
                    clear-icon="mdi-trash-can-outline"
                    @blur="getPrice(item)"
                    @click:clear="countChange(item)"
                  />
                </v-row>
                <v-row
                  class=" py-0 pl-4 mb-2"
                  style="height: 25px;max-width: 110px"
                >
                  <v-col>
                    {{ (item.fee ? $numberFormat(item.fee) +' '+$store.state.currencyName : '') }}
                  </v-col>
                </v-row>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="! showSelectedItem">
              <v-list-item-content>
                <div
                  v-if="page < lastPage && !selectByBarcode"
                  v-observe-visibility="{
                    callback: visibilityChanged
                  }"
                  class="text-center"
                >
                  <v-progress-circular
                    :size="20"
                    :width="2"
                    color="primary"
                    indeterminate
                  />
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
    <v-bottom-sheet v-model="sheet">
      <v-sheet
        class="text-center"
        height="300px"
      >
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet = !sheet"
        >
          {{ $t('close') }}
        </v-btn>
        <v-row class="mx-0">
          <v-col
            class="mb-0 pb-0 px-1"
            style="height: 55px"
            cols="12"
            md="4"
            sm="4"
          >
            <combobox
              v-model="productGroup"
              :multiple_="true"
              :label="$t('product-group')"
              type="productGroup"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            sm="4"
            class="mb-0 pb-0 px-1"
            style="height: 55px"
          >
            <combobox
              ref="category"
              v-model="productCat1"
              :multiple_="true"
              :label="$t('product-cat1')"
              :filter="(sheet ? {'group': productGroup} : null)"
              type="productCat1"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            sm="4"
            class="mb-0 pb-0 px-1"
            style="height: 55px"
          >
            <combobox
              v-model="productCat2"
              :multiple_="true"
              :filter="(sheet ? {'cat1': productCat1} : null)"
              :label="$t('product-cat2')"
              type="productCat2"
            />
          </v-col>
        </v-row>
        <v-row class="mx-0">
          <v-col
            cols="12"
            sm="1"
            class="mb-1"
            md="1"
          >
            <v-switch
              v-model="availableGoods"
              :label="$t('only-available-goods')"
              @change="searchItems"
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>
    <v-card
      class="bottomSummery my-0"
      elevation="10"
      outlined
    >
      <v-sheet
        class="text-center"
        :height="bottomSummeryHeight"
      >
        <v-row
          style="box-shadow: 0 -4px 6px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)"
          class="mx-0 d-flex"
        >
          <v-col
            class="mb-0 pt-1 pb-0 px-1"
            cols="6"
          >
            <v-badge
              v-if="! showSelectedItem"
              :content="items.length"
              :value="items.length"
              color="green"
              overlap
              class="float-right "
            >
              <v-btn
                class="white--text mr-5 mt-2"
                color="primary"
                small
                depressed
                @click="showSelected"
              >
                {{ $t('selected-product') }}
                <v-icon
                  right
                >
                  mdi-playlist-check
                </v-icon>
              </v-btn>
            </v-badge>
            <v-btn
              v-if="showSelectedItem"
              class="white--text mr-9 float-right mt-2 "
              color="green"
              small
              depressed
              @click="showSelected"
            >
              {{ $t('add-product') }}
              <v-icon
                right
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
          <v-col
            class="mb-0 pb-0 px-1 pt-0"
            cols="6"
          >
            <v-expansion-panels
              v-model="bottomPanel"
              flat
            >
              <v-expansion-panel>
                <v-expansion-panel-header
                  v-slot="{ open }"
                  class="py-0"
                >
                  <v-row
                    no-gutters
                  >
                    <v-col
                      cols="12"
                      class="text--secondary"
                    >
                      <v-btn
                        v-if="! open"
                        class="white--text float-left ml-3 mt-1"
                        color="light-blue accent-4"
                        small
                        style="margin-top: -8px"
                        depressed
                      >
                        {{ $t('sum') }}  {{ $numberFormat(sumPrice-sumDiscount+sumTax) }}  {{ $store.state.currencyName }}
                        <v-icon
                          right
                        >
                          mdi-eye
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row
                    justify="space-around"
                    no-gutters
                  />
                  <v-col
                    cols="12"
                    class="text--secondary py-0"
                  >
                    <v-btn
                      class="white--text ml-3"
                      color="green"
                      small
                      text
                      depressed
                    >
                      {{ $t('sum-total') }}  {{ $numberFormat(sumPrice) }}  {{ $store.state.currencyName }}
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    class="text--secondary py-0"
                  >
                    <v-btn
                      class="white--text ml-3"
                      color="error"
                      small
                      text
                      depressed
                      @click="taxDialog = true"
                    >
                      {{ $t('discount') }}  {{ $numberFormat(sumDiscount) }}  {{ $store.state.currencyName }} -
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    class="text--secondary py-0"
                  >
                    <v-btn
                      class="white--text  ml-3"
                      color="green"
                      small
                      text
                      depressed
                      @click="taxDialog = true"
                    >
                      {{ $t('tax') }}  {{ $numberFormat(sumTax) }}  {{ $store.state.currencyName }}
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    class="text--secondary py-0"
                  >
                    <v-btn
                      class="white--text ml-3"
                      color="green"
                      small
                      text
                      depressed
                    >
                      {{ $t('sum-total') }}  {{ $numberFormat(sumPrice-sumDiscount+sumTax) }}  {{ $store.state.currencyName }}
                    </v-btn>
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
    />
  </v-card>
</template>

<script>
  export default {
    components: {
      Combobox: () => import('../combobox/Combobox'),
      Product: () => import('../../../pages/product/product'),
      Snakbar: () => import('../snakbar/snakbar'),
    },
    props: ['header', 'customer', 'invoice', 'row', 'edit'],
    data () {
      return {
        page: 1,
        lastPage: 10000,
        options: {
          locale: 'en-US',
          prefix: '',
          suffix: '  ریال  ',
          precision: 0,
        },
        feeRules: [
          v => !!v || 'Name is required',
          v => (v && v > 0) || 'Name must be less than 10 characters',
        ],
        listHeight: 500,
        selectByBarcode: false,
        recipientAccount: null,
        footer: null,
        snakbarText: null,
        productDialog: false,
        taxDialog: false,
        snakbar: false,
        sumDiscountPercent: null,
        bottomPanel: null,
        date: null,
        snakbarColor: null,
        lists: [],
        bottomSummeryHeight: 'auto',
        selected: 0,
        items: [],
        showSelectedItem: false,
        submitLoading: false,
        newProduct: null,
        productGroup: null,
        productCat1: null,
        productCat2: null,
        search: null,
        entrepot: null,
        list: null,
        type: 'productService',
        loading: false,
        searchDisable: false,
        sheet: false,
        bottomSummery: false,
        availableGoods: false,
        sumPrice: 0,
        sumDiscount: 0,
        sumTax: 0,
        timerPrice: 0,
        timerSearch: 0,
        tax: false,
        discountRules: [
          v => (v && v <= 100) || 'Max should not be above £50,000',
        ],
      }
    },
    watch: {
      items () {
        this.$emit('input', this.$data)
      },
      invoice () {
        if (this.invoice) {
          this.items = this.invoice.articles
          this.showSelectedItem = false
          this.showSelected()
        }
      },
      sheet () {
        if (!this.sheet) {
          this.page = 1
          this.search = ''
          this.searchItems()
        }
      },
      newProduct  () {
        this.search = this.newProduct
        this.searchItems()
        this.productDialog = false
      },
      entrepot  () {
        this.searchItems()
      },
      search () {
        this.page = 1
        this.lastPage = 100000
        this.searchItems()
      },
    },
    activated: function () {
      this.countCheck()
    },
    mounted () {
      if (this.edit) {
        this.showSelectedItem = false
      } else {
        this.search = ''
      }
    },
    beforeRouteLeave (to, from, next) {
      var goNext = false
      if (this.lists) {
        this.lists.map(function (value, key) {
          if (value.dialog) {
            value.dialog = false
            goNext = true
          }
        })
      }

      if (this.bottomPanel === 0) {
        this.bottomPanel = null
        goNext = true
      }
      if (!goNext) {
        next()
      } else {
        next(false)
      }
    },
    created () {
      window.addEventListener('resize', this.resizeHeightBody)
    },
    destroyed () {
      window.removeEventListener('resize', this.resizeHeightBody)
    },
    methods: {
      changeSelectByBarcode () {
        if (this.selectByBarcode) {
          this.selectByBarcode = false
        } else {
          this.selectByBarcode = true
        }
      },
      visibilityChanged (e) {
        if (this.showSelectedItem) {
          e && this.searchItems()
        }
      },
      SetValueMinFee (item) {
        item.feeAlert = true
      },
      SetValueMaxFee (item) {
        item.feeAlert = false
      },
      SetValueMaxTotalDiscountPercent () {
        if (this.sumDiscountPercent > 100) {
          this.sumDiscountPercent = 100
        }
        this.totalDiscountPercentCheck()
      },
      SetValueMaxTotalDiscount () {
        this.sumDiscount = this.sumPrice
        this.sumTax = (parseInt(this.sumPrice) - parseFloat(this.sumDiscount)) * this.$store.state.tax / 100
      },
      totalDiscount () {
        this.items.map(function (value, key) {
          value.discount = 0
        })
        var percent = this.sumDiscount / this.sumPrice * 100
        if (percent > 100) {
          percent = 100
        }
        this.sumTax = (parseInt(this.sumPrice) - parseFloat(this.sumDiscount)) * this.$store.state.tax / 100
        this.sumDiscountPercent = percent
      },
      SetValueMaxDiscount (item) {
        item.discount = item.fee * item.count
      },
      SetValueMaxDiscountPercent (item) {
        item.discountPercent = 100
      },
      totalDiscountPercentCheck () {
        this.sumDiscount = this.sumPrice * (this.sumDiscountPercent / 100)
        this.sumTax = (parseInt(this.sumPrice) - parseFloat(this.sumDiscount)) * this.$store.state.tax / 100
      },
      discountPercentCheck (item) {
        if (item.discountPercent > 100) {
          item.discountPercent = 100
        }
        item.discount = (item.count * item.fee) * (item.discountPercent / 100)
        this.calculate()
      },
      discount (item) {
        var percent = (item.discount / (item.fee * item.count)) * 100
        if (percent > 100) {
          percent = 100
        }
        item.discountPercent = percent
        this.calculate()
      },
      showSelected () {
        if (this.showSelectedItem) {
          this.lists = []
          this.showSelectedItem = false
          this.search = ''
          this.searchItems()
        } else {
          this.showSelectedItem = true
          this.loading = false
          this.lists = this.items
          this.calculate()
        }
      },
      calculate () {
        var app = this
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.sumPrice = 0
          app.sumDiscount = 0
          app.sumDiscountPercent = 0
          app.sumTax = 0
          app.items.map(function (value, key) {
            app.sumPrice = app.sumPrice + parseInt(value.fee * value.count)
            app.sumDiscount = Number(app.sumDiscount) + Number(value.discount)
            if (app.tax) {
              value.tax = (parseInt(value.fee * value.count) - Number(value.discount)) * app.$store.state.tax / 100
              app.sumTax = Number(app.sumTax) + Number(value.tax)
            }
          })
          var percent = app.sumDiscount / app.sumPrice * 100
          if (percent > 100) {
            percent = 100
          }
          app.sumDiscountPercent = percent
        }, 500)
      },
      countChange (item) {
        if (parseInt(item.entrepot) !== parseInt(this.entrepot)) {
          this.snakbarText = this.$t('alert-is-not-equal-entrepot-with-select-good')
          this.snakbarColor = 'red'
          this.snakbar = true
          return false
        } else {
          var app = this
          clearTimeout(this.timer)
          this.timer = setTimeout(function () {
            if (item.count > 0) {
              app.getPrice(item)
            } else {
              app.items.map(function (value, key) {
                if (item.code === value.code) {
                  app.items.splice(key, 1)
                  item.count = null
                  item.fee = null
                  item.discount = null
                  item.tax = null
                }
              })
              app.calculate()
            }
            if (app.items.length > 0) {
              app.bottomSummery = true
            } else {
              app.bottomSummery = false
            }
          }, 500)
        }
      },
      countCheck () {
        var app = this
        var text = this.$t('alert-remove-goods-cause-of-not-have-stock')
        var goods = ''
        if (app.header.invoiceType === 1) {
          app.items.map(function (value, index) {
            if (parseFloat(value.count) > parseFloat(value.stock)) {
              value.count = 0
              value.fee = null
              value.discount = null
              value.tax = null
              goods = goods + '-' + value.name
            }
          })
          if (goods !== '') {
            this.snakbarText = text + ':' + goods
            this.snakbarColor = 'red'
            this.snakbar = true
          }
        }
      },
      openDialog (item) {
        if (item.fee > 0) {
          var fee = item.fee
          item.fee = parseInt(fee)
        }
        item.dialog = true
      },
      openSheet () {
        this.sheet = true
      },
      head () {
        this.$emit('back')
      },
      click (item, i) {
        if (parseInt(item.entrepot) !== parseInt(this.entrepot) && item.type === 8) {
          this.snakbarText = this.$t('alert-is-not-equal-entrepot-with-select-good')
          this.snakbarColor = 'red'
          this.snakbar = true
          return false
        } else {
          // var x = this.items.findIndex(x => x.id === this.oldText)
          item.count++
          if (this.header.invoiceType === 1 && item.type === 8) { // if invoice is sale
            if (item.count <= item.stock) {
              this.selected = i
              this.getPrice(item)
            } else {
              item.count--
              this.snakbarText = this.$t('alert-is-not-enough-inventory')
              this.snakbarColor = 'red'
              this.snakbar = true
            }
          } else {
            this.selected = i
            if (item.type === 8) {
              this.getPrice(item)
            } else {
              this.addItem(item)
            }
          }
        }
      },
      onScroll () {
      },
      store () {
        var app = this
        app.header.discount = app.sumDiscount
        app.header.tax = app.sumTax
        app.header.discountPercent = app.sumDiscountPercent
        this.submitLoading = true
        if (this.items.length === 0) {
          this.snakbarText = this.$t('alert-not-selected-product')
          this.snakbar = true
          app.submitLoading = false
        } else {
          app.$axios.post(app.$endpoint + 'sellInvoice', {
            params: {
              header: app.header,
              items: app.items,
            },
          })
            .then(res => {
              res = res.data
              this.snakbarColor = 'green'
              this.snakbarText = this.$t('success-submit')
              this.snakbar = true
              // app.items = []
              // app.$router.push({ name: 'Sell', params: {} })
              app.submitLoading = false
              this.$router.push({ name: 'SellPrint', params: { id: res.id_ } })
            })
            .catch((err) => {
              var app = this
              var error = err.response.data.errors
              error = Object.keys(error).map((key) => [error[key]])
              var msg = app.$t('alert-do-resolved-errors') + ' : '
              error.map(function (value, key) {
                var res = value[0][0].split('|')
                var text = res[0]
                var item = res[1].split('.')
                msg = msg + '#' + app.$t(text) + '-' + app.items[item[1]].name + '-' + app.items[item[1]].code
              })
              this.snakbarText = msg
              this.snakbarColor = 'red'
              this.snakbar = true
            })
            .finally(() => {
              app.submitLoading = false
            })
        }
      },
      test: function (event) {
        switch (event.keyCode) {
          case 38:
            if (this.selected === null) {
              this.selected = 0
            } else if (this.selected > 0) {
              this.selected--
              this.lists[this.selected + 1].selected = false
              this.lists[this.selected].selected = true
            }
            this.fixScrolling()
            break
          case 40:
            if (this.selected === null) {
              this.selected = 0
            } else if (this.selected < this.lists.length - 1) {
              this.selected++
              this.lists[this.selected - 1].selected = false
              this.lists[this.selected].selected = true
            }
            this.fixScrolling()
            break
          case 13:
            if (this.selected >= 0) {
              this.click(this.lists[this.selected], this.selected)
            }
            break
        }
        if (this.selected > 0) {
          this.list = this.lists[this.selected]
        }
      },
      fixScrolling () {
        if (this.selected >= 0 && this.lists.length > 0) {
          const liH = this.$refs.test[this.selected].$el.clientHeight
          this.$refs.scrollContainer.$el.scrollTop = liH * this.selected
        }
      },
      close () {
        this.$router.go(-1)
      },
      getPrice (item) {
        if (this.search == null) {
          return false
        }
        var data = {}
        data.getprice = 'sell'
        data.unit = item.unit_id
        data.procode = item.code
        data.productId = item.productId
        data.sellkind = this.header.sellType
        data.buyerCode = this.header.customer.code
        data.buyer = this.header.customer.group_id
        data.currency = 1
        data.count = item.count
        var app = this
        item.loading = true
        clearTimeout(this.timerPrice)
        this.timerPrice = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getsellprice', {
            params: data,
          })
            .then(res => {
              item.fee = res.data.price
              app.addItem(item)
            })
            .finally(() => (item.loading = false))
        }, 400)
      },
      resizeHeightBody () {
        this.listHeight = this.$refs.mainCard.$el.clientHeight - 240
      },
      addItem (item) {
        var check = null
        var app = this
        app.items.map(function (value, key) {
          if (item.code === value.code) {
            check = true
            value.count = item.count
            if (!value.count || value.count === 0) {
              app.searchItems.splice(key, 1)
            }
          }
        })
        if (!check) {
          app.bottomSummery = true
          app.items.push(item)
        }
        app.calculate()
      },
      searchItems () {
        var timeout = 800
        if (this.selectByBarcode) {
          timeout = 50
        }
        if (!this.edit && this.showSelectedItem === true) {
          return false
        }
        if (this.search == null || this.page > this.lastPage || this.entrepot == null) {
          return false
        }
        var app = this
        clearTimeout(this.timerSearch)
        this.timerSearch = setTimeout(function () {
          this.loading = true
          if (app.selectByBarcode) {
            // app.searchDisable = true
          }
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              page: app.page,
              select: app.type,
              entrepot: app.entrepot,
              search: app.search,
              group: app.productGroup,
              cat1: app.productCat1,
              cat2: app.productCat2,
              stock: app.availableGoods,
              selectedItems: app.items,
            },

          })
            .then(res => {
              res = res.data
              app.lastPage = res.last_page
              if (app.search !== '' && app.page < 2) {
                app.lists = []
                app.$refs.scrollContainer.$el.scrollTop = 0
              }
              app.lists = [
                ...app.lists,
                ...Array.from(res.data),
              ]
              if (app.page > 1) {
                app.lists = [
                  ...app.lists,
                  ...Array.from(res.data),
                ]
              } else {
                app.lists = res.data
              }
              if (app.selectByBarcode && app.lists.length === 1) {
                app.search = ''
                app.click(app.lists[0], 0)
              }
              app.listHeight = app.$refs.mainCard.$el.clientHeight - 240
            }).finally(() => {
              if (app.lastPage > app.page) {
                app.page++
              }
              app.searchDisable = false
              app.loading = false
            })
        }, timeout)
      },
    },
  }
</script>

<style>
  .dense > .v-input__control {
    min-height: 30px !important;
  }
  .border-item {
    border: #0066FF solid 1px;
  }
  .bottomSummery {
    position: fixed;
    height: auto;
    bottom: 0;
    width: 100%;
  }
</style>
